import { CommonProps } from '@repo/types'
import { merge } from '@repo/ui'
import { observer } from 'mobx-react-lite'
import React from 'react'

import StoreService from '@/store/StoreService'

import { Image } from './Image'
import { Logo } from './Logo'

export const BrandImage = observer(function BrandImage({
  className
}: CommonProps): React.ReactElement {
  const { host } = StoreService.getStore()

  if (host?.brandImageUrl) {
    return (
      <BrandImageContainer className={merge(className)}>
        <Image alt='Logo' className='object-contain' src={host.brandImageUrl} />
      </BrandImageContainer>
    )
  }

  return (
    <BrandImageContainer className={merge('bg-shade-0 items-center justify-center p-3', className)}>
      <Logo />
    </BrandImageContainer>
  )
})

const BrandImageContainer = observer(function BrandImageContainer({
  children,
  className
}: CommonProps) {
  return (
    <div
      className={merge(
        'flex w-32 h-32 flex-shrink-0 aspect-square overflow-hidden rounded-xl',
        className
      )}
    >
      {children}
    </div>
  )
})
